import React from 'react';
import '../../style/bonus.scss';
import Button from '@material-ui/core/Button';
import CropFreeIcon from '@material-ui/icons/CropFree';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import PermPhoneMsgRoundedIcon from '@material-ui/icons/PermPhoneMsgRounded';
import { useHistory } from 'react-router';
import HourglassEmptyRoundedIcon from '@material-ui/icons/HourglassEmptyRounded';
import LinkRoundedIcon from '@material-ui/icons/LinkRounded';
import CheckBoxRoundedIcon from '@material-ui/icons/CheckBoxRounded';
import CardTravelRoundedIcon from '@material-ui/icons/CardTravelRounded';
import RestaurantLayout from '../../components/Restaurant/RestaurantLayout';

const Index = () => {
  const history = useHistory();

  const handleToScanQRCode = () => {
    history.push('/ScanQRCode');
  };

  const handleToMarkUpBonus = () => {
    history.push('/bonus/markup');
  };

  const handleToPhoneCode = () => {
    history.push('/PhoneConfirmCodeList');
  };

  const handleToGuestCardInUseList = () => {
    history.push('/GuestCardInUseList');
  };

  const handleToLinkBonusProductQRCode = () => {
    history.push('/BonusProduct/LinkBonusProductQRCode');
  };

  const handleToUseBonusProductQRCode = () => {
    history.push('/BonusProduct/UseBonusProductQRCode');
  };

  const handleToGroupBonusProductQRCode = () => {
    history.push('/BonusProduct/GroupBonusProductQRCode');
  };

  return (
    <RestaurantLayout>
      <div>
        <div className="bonus__title">共用掃描功能</div>

        <div className="bonus__btns">
          <Button
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            startIcon={<CropFreeIcon />}
            onClick={handleToScanQRCode}>
            掃描 QRCODE
          </Button>
        </div>

        <div className="bonus__title">點數功能</div>

        <div className="bonus__btns">
          <Button
            variant="contained"
            color="secondary"
            size="large"
            fullWidth
            startIcon={<AddCircleOutlineIcon />}
            onClick={handleToMarkUpBonus}>
            補登點數
          </Button>

          <Button
            variant="contained"
            color="default"
            size="large"
            fullWidth
            startIcon={<PermPhoneMsgRoundedIcon />}
            onClick={handleToPhoneCode}>
            顯示有效會員驗證碼
          </Button>
        </div>

        <div className="bonus__title">共享空間功能</div>

        <div className="bonus__btns">
          <Button
            variant="contained"
            color="default"
            size="large"
            fullWidth
            startIcon={<HourglassEmptyRoundedIcon />}
            onClick={handleToGuestCardInUseList}>
            目前已啟用的卡片
          </Button>
        </div>

        <div className="bonus__title">紙本掃描</div>

        <div className="bonus__btns">
          <Button
            variant="contained"
            color="default"
            size="large"
            fullWidth
            startIcon={<CardTravelRoundedIcon />}
            onClick={handleToGroupBonusProductQRCode}>
            打包
          </Button>

          <Button
            variant="contained"
            color="default"
            size="large"
            fullWidth
            startIcon={<LinkRoundedIcon />}
            onClick={handleToLinkBonusProductQRCode}>
            歸戶
          </Button>

          <Button
            variant="contained"
            color="default"
            size="large"
            fullWidth
            startIcon={<CheckBoxRoundedIcon />}
            onClick={handleToUseBonusProductQRCode}>
            使用
          </Button>
        </div>
      </div>
    </RestaurantLayout>
  );
};

export default Index;
